import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {
    getStaffMedicos(context, dados) {
        if (((!dados.pagina) || (!dados.quantidadePorPagina)) && (!dados.zero)) {
            dados.pagina = 1;
            dados.quantidadePorPagina = 25;
        }
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("staffMedicos/access/listar", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getStaffMedicosDoDia(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("staffMedicos/access/listarMedicoDoDia", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getStaffMedicosSimples() {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.get("staffMedicos/access/listarSimples").then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getStaffMedicosBox(context, filtros) {
        filtros.componente = "SearchBoxStaffMedico";
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("staffMedicos/access/listaBox", filtros).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getStaffMedico(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("staffMedicos/access/obter", { ID_MEDICO: dados.id, componente: dados.componente }).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getStaffMedicoImagens(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("staffMedicos/access/obterMedicoImagens", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getStaffMedicoSimples(context, idMedico) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("staffMedicos/access/obterSimples", { ID_MEDICO: idMedico }).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getStaffMedicoWeb(context, idMedico) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("medicos/access/obterMedicoWeb", { ID_MEDICO: idMedico }).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    async getStaffMedicoUsuario() {
        if (!JwtService.getToken()) throw new Error("Sessão expirada");
        ApiService.setHeader();
        const { data } = await ApiService.get("staffMedicos/access/obterMedicoUsuario");
        if (!data || typeof data !== "object" || Array.isArray(data) || data.resultado === false) {
            throw new Error("Não foi possível identificar o médico do usuário");
        }
        return data;
    },
    listarMedicosUsuario() {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.get("staffMedicos/access/listarMedicosUsuario").then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getStaffMedicoEspecialidades(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("staffMedicos/access/listarEspecialidades", {
                    ID_MEDICO: dados.id,
                    ID_UNIDADE: dados.idUnidade
                }).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getStaffMedicoEspecialidadesMedicas(context, idMedico) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("staffMedicos/access/listarEspecialidadesMedicas", {ID_MEDICO: idMedico}).then(({ data }) => {resolve(data);
                });
            }
        });
    },
    async getStaffMedicoPorEspecialidades(context, dados) {
        if (!JwtService.getToken()) throw new Error("Sessão expirada");
        ApiService.setHeader();
        const { data } = await ApiService.postOnce("staffMedicos/access/listarMedicosPorEspecialidades", dados, { timeout: 30000 });
        if (!Array.isArray(data)) throw new Error("Resposta de médicos inválida");
        return data;
    },
    async getStaffMedicoPorProduto(context, dados) {
        if (!JwtService.getToken()) throw new Error("Sessão expirada");
        ApiService.setHeader();
        const { data } = await ApiService.postOnce("staffMedicos/access/listarMedicosPorProduto", dados, { timeout: 30000 });
        if (!Array.isArray(data)) throw new Error("Resposta de médicos inválida");
        return data;
    },
    async getStaffMedicoPelaRegra(context, dados) {
        if (!JwtService.getToken()) throw new Error("Sessão expirada");
        ApiService.setHeader();
        const { data } = await ApiService.postOnce("staffMedicos/access/listarMedicosPelaRegra", dados, { timeout: 30000 });
        if (!Array.isArray(data)) throw new Error("Resposta de médicos inválida");
        return data;
    },
    deleteStaffMedico(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("staffMedicos/access/excluir", { ID_MEDICO: dados.id, componente: dados.componente }).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    postStaffMedico(context, staffMedico) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("staffMedicos/access/salvar", staffMedico).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getModelosLaudos(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("staffMedicos/access/modelosLaudos", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    postMedicoHorarioPorIntervalo(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("staffMedicos/access/salvarMedicoHorarioPorIntervalo", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    postMedicoHorarioPorDiaSemana(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("staffMedicos/access/salvarMedicoHorarioPorDiaSemana", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getMedicoHorarios(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("staffMedicos/access/listarHorarios", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getMedicoHorariosAvulsos(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("staffMedicos/access/listarHorariosAvulsos", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getMedicoHorariosBloqueados(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("staffMedicos/access/listarHorariosBloqueados", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    deleteStaffMedicoHorario(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("staffMedicos/access/excluirHorario", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    deleteStaffMedicoHorarioAvulso(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("staffMedicos/access/excluirHorarioAvulso", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    deleteStaffMedicoHorarioBloqueado(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("staffMedicos/access/excluirHorarioBloqueado", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getMedicosUsuarios(context, idMedico) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("staffMedicos/access/obterUsuarios", idMedico).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getMedicosAtendimentos(context, idMedico) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("staffMedicos/access/listarMedicoAtendimentosTipo", idMedico).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};
